import { c as _c } from "react/compiler-runtime";
import { Input } from '@repo/ui/components';
import { useMemo, useState } from 'react';
import { debounce } from '../lib/debounce';
export function DebouncedInput(t0) {
  const $ = _c(16);
  let initialValue;
  let onChange;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      debounceMs: t1,
      onChange,
      value: initialValue,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = initialValue;
    $[2] = onChange;
    $[3] = props;
    $[4] = t1;
  } else {
    initialValue = $[1];
    onChange = $[2];
    props = $[3];
    t1 = $[4];
  }
  const debounceMs = t1 === undefined ? 500 : t1;
  const [value, setValue] = useState(initialValue);
  const [syncedValue, setSyncedValue] = useState(initialValue);
  if (initialValue !== syncedValue) {
    setSyncedValue(initialValue);
    setValue(initialValue);
  }
  let t2;
  if ($[5] !== onChange) {
    t2 = newValue => {
      onChange(newValue);
    };
    $[5] = onChange;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== debounceMs || $[8] !== t2) {
    t3 = debounce(t2, debounceMs);
    $[7] = debounceMs;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const debouncedOnChange = t3;
  let t4;
  if ($[10] !== debouncedOnChange) {
    t4 = e => {
      const newValue_0 = e.target.value;
      setValue(newValue_0);
      debouncedOnChange(newValue_0);
    };
    $[10] = debouncedOnChange;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleChange = t4;
  let t5;
  if ($[12] !== handleChange || $[13] !== props || $[14] !== value) {
    t5 = <Input {...props} onChange={handleChange} value={value} data-sentry-element="Input" data-sentry-component="DebouncedInput" data-sentry-source-file="debounced-input.tsx" />;
    $[12] = handleChange;
    $[13] = props;
    $[14] = value;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}